var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserSm = function SvgUserSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    d: "M12.5 12.5a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5m2.833-4.25a2.834 2.834 0 1 1-5.667 0 2.834 2.834 0 0 1 5.667 0M21 19.583C21 21 19.583 21 19.583 21H5.417S4 21 4 19.583c0-1.416 1.417-5.666 8.5-5.666s8.5 4.25 8.5 5.666m-1.417-.005c-.001-.349-.218-1.397-1.178-2.358-.924-.923-2.662-1.887-5.905-1.887s-4.981.964-5.905 1.887c-.96.96-1.175 2.01-1.178 2.358z"
  })));
};
export default SvgUserSm;